require("../../../static/js/inject-bootstrap.js");
window['$'] = window['jQuery'] = require("../../../static/js/jquery/jquery-3.3.1.min.js");
window['Popper'] = require("../../../static/js/popper.min.js");
require("../../../static/js/gateway.js");
require("../../../static/js/jquery.jqtransform.js");
require("../../../static/js/main_etf.js");
require("../../../static/js/mobile-responsive.js");
require("../../../static/js/jquery-ui-1.8.7.min.js");
require("../../../static/js/eu/cookie-disclaimer.js");
require("../../../static/js/slick/slick.min.js");
require("../../../static/js/header/scripts.js");
require("../../../static/eu/js/header/header-override.js");
